module.exports = "/assets/data/cdb8bd79ff0438af4de93bf6b6725018-BN1.data.json";